import { Component } from 'react'
import { connect } from 'react-redux'
import ProgrammableLink from '../ProgrammableLink'
import { updateContentTypeSearchParameters } from '../../../store/actions/search'
import { graphqlFetch } from '../../cdl-react-components/utilities'

class CrownLandButton extends Component {
    state = {}

    handleBeforeRedirect = () => new Promise((res) => {
        this.props.updateContentTypeSearchParameters('regionalMaps')
        res()
    })

    render() {
        const { id } = this.state

        return id ? ( 
            <ProgrammableLink
                onBeforeRedirect={this.handleBeforeRedirect}
                href={`/map/${id}`}>
                <img
                    className="crown-land-button__img"
                    src="https://webfiles.canadiandiscovery.com/public/CDD/images/crown-land-banner.jpg"
                    alt="Montney Crown Land Map"
                    style={{ marginBottom: '16px', width: '100%', cursor: 'pointer', border: '.5px solid black' }} />
            </ProgrammableLink>
        ) : null
    }

    componentDidMount() {        
        // Note: HotChocolate needs to query the pubDate & mapType in order to do the "where", don't remove them from this query - rrogers 2026-02-17
        graphqlFetch('wcms3', `
            query {
                regionalMaps (
                    where: { contentRegionalmapMapTypes: { all: { maptype: { name: { eq: "Crown Majority Rights Holders" }}}}}
                    order: { publicationDate: DESC }
                    take: 1
                ) {
                    items {
                        id
                        publication_date: publicationDate
                        contentRegionalmapMapTypes {
                            maptype {
                                name
                            }
                        }
                    }
                }
            }`)
            .then(res => {
                const map = res.data.regionalMaps.items[0]
                if (map)
                    this.setState({ id: map.id })
            })
    }
}

const mapDispatchToProps = (dispatch) => ({
    updateContentTypeSearchParameters: (keyword) => dispatch(updateContentTypeSearchParameters(keyword))
})

export default connect(null, mapDispatchToProps)(CrownLandButton)